import { useState } from "react";

interface FaqAccordionProps {
  items: { q: string; a: string }[];
  defaultOpen?: number;
}

export default function FaqAccordion({ items, defaultOpen = -1 }: FaqAccordionProps) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="divide-y divide-background-200/70 border-t border-b border-background-200/70">
      {items.map((item, index) => {
        const isOpen = open === index;
        return (
          <article key={item.q} itemScope itemType="https://schema.org/Question">
            <h3 className="m-0">
              <button
                type="button"
                onClick={() => setOpen(isOpen ? -1 : index)}
                aria-expanded={isOpen}
                className="w-full flex items-center justify-between gap-4 py-5 text-left cursor-pointer group"
              >
                <span
                  itemProp="name"
                  className={`font-heading text-base md:text-lg font-semibold transition-colors ${
                    isOpen ? "text-primary-500" : "text-foreground-950 group-hover:text-primary-500"
                  }`}
                >
                  {item.q}
                </span>
                <span
                  className={`shrink-0 w-8 h-8 flex items-center justify-center rounded-md border transition-colors ${
                    isOpen ? "bg-primary-500 border-primary-500 text-background-50" : "border-background-200 text-foreground-600"
                  }`}
                >
                  <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                </span>
              </button>
            </h3>
            <div itemScope itemType="https://schema.org/Answer" className={isOpen ? "block pb-5 pr-10" : "hidden"}>
              <p itemProp="text" className="text-sm md:text-base leading-7 text-foreground-500">
                {item.a}
              </p>
            </div>
          </article>
        );
      })}
    </div>
  );
}